import React from "react";

const Skils = () => {
  return (
    <div id="skils" style={{ backgroundColor: "#212529" }}>
      <h1 className="text-center py-5 " style={{ color: "#ffa500" }}>
        My Skills
      </h1>

      <div className="container">
        <div className="row">
          <div className="col-sm-12 col-md-6 p-2">
            <h4 className="p-3 text-white text-center">WEB DESIGN</h4>
            <div className="progress">
              <div
                className="progress-bar"
                role="progressbar"
                style={{ width: "99%" }}
                aria-valuenow="25"
                aria-valuemin="0"
                aria-valuemax="100"
              >
                99%
              </div>
            </div>
            <h4 className="p-3 text-white text-center">REACT JS</h4>
            <div className="progress">
              <div
                className="progress-bar"
                role="progressbar"
                style={{ width: "85%" }}
                aria-valuenow="25"
                aria-valuemin="0"
                aria-valuemax="100"
              >
                85%
              </div>
            </div>
            <h4 className="p-3 text-white text-center">HTML/CSS</h4>
            <div className="progress">
              <div
                className="progress-bar"
                role="progressbar"
                style={{ width: "95%" }}
                aria-valuenow="25"
                aria-valuemin="0"
                aria-valuemax="100"
              >
                95%
              </div>
            </div>
          </div>
          <div className="col-sm-12 col-md-6 p-2 pb-5">
            <h4 className="p-3 text-white text-center">BOOTSTRAP</h4>
            <div className="progress">
              <div
                className="progress-bar"
                role="progressbar"
                style={{ width: "92%" }}
                aria-valuenow="25"
                aria-valuemin="0"
                aria-valuemax="92"
              >
                92%
              </div>
            </div>
            <h4 className="p-3 text-white text-center">NODE JS</h4>
            <div className="progress">
              <div
                className="progress-bar"
                role="progressbar"
                style={{ width: "80%" }}
                aria-valuenow="25"
                aria-valuemin="0"
                aria-valuemax="65"
              >
                80%
              </div>
            </div>
            <h4 className="p-3 text-white text-center">EXPRESS JS</h4>
            <div className="progress">
              <div
                className="progress-bar"
                role="progressbar"
                style={{ width: "80%" }}
                aria-valuenow="80"
                aria-valuemin="0"
                aria-valuemax="80"
              >
                80%
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Skils;
